import React, { useState, useEffect } from 'react';

const BookingEmbed = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const companyId = new URLSearchParams(window.location.search).get('company_id') || '';
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [inquiryNumber, setInquiryNumber] = useState('');
  const [error, setError] = useState('');
  const [showEmbed, setShowEmbed] = useState(false);

  const [form, setForm] = useState({
    contact_name: '', contact_phone: '', contact_email: '',
    from_location_name: '', to_location_name: '',
    vehicle_type_name: '', vehicle_size: '',
    no_of_vehicles: 1, weight: '',
    load_type: '', trip: '', trip_type: '',
    remarks: '',
  });

  const handleChange = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.contact_name || !form.contact_phone) {
      setError('Name and Phone are required'); return;
    }
    setSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${backendUrl}/api/booking-requests/external${companyId ? '?company_id=' + companyId : ''}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Failed');
      setInquiryNumber(data.inquiry_number);
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally { setSubmitting(false); }
  };

  // Embed code
  const embedCode = `<iframe src="${backendUrl || window.location.origin}/booking/embed${companyId ? '?company_id=' + companyId : ''}" width="100%" height="700" frameborder="0" style="border:none;border-radius:12px;box-shadow:0 2px 12px rgba(0,0,0,0.08);"></iframe>`;

  const inputClass = "w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";
  const labelClass = "block text-sm font-semibold text-gray-700 mb-1";

  if (submitted) {
    return (
      <div style={{ maxWidth: 600, margin: '40px auto', padding: 32, background: '#fff', borderRadius: 16, textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#16a34a', color: '#fff', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32 }}>&#10003;</div>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', marginBottom: 8 }}>Booking Request Submitted!</h2>
        <p style={{ color: '#666', marginBottom: 4 }}>Your inquiry number is:</p>
        <p style={{ fontSize: 28, fontWeight: 700, color: '#1a5ab8', marginBottom: 20 }}>{inquiryNumber}</p>
        <p style={{ color: '#888', fontSize: 14 }}>Our team will contact you shortly.</p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 720, margin: '20px auto', padding: 24, background: '#fff', borderRadius: 16, fontFamily: 'Arial, sans-serif' }}>
      {/* Internal: Embed code section */}
      <div style={{ marginBottom: 24, padding: 16, background: '#f0f9ff', borderRadius: 8, border: '1px solid #bae6fd' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#0369a1' }}>Embed Code</span>
          <button onClick={() => setShowEmbed(!showEmbed)}
            style={{ fontSize: 12, color: '#0369a1', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
            {showEmbed ? 'Hide' : 'Show'} Code
          </button>
        </div>
        {showEmbed && (
          <div>
            <textarea readOnly value={embedCode}
              style={{ width: '100%', height: 80, fontFamily: 'monospace', fontSize: 11, padding: 8, border: '1px solid #ddd', borderRadius: 4, resize: 'none', background: '#f8fafc' }} />
            <button onClick={() => { navigator.clipboard.writeText(embedCode); }}
              style={{ marginTop: 4, fontSize: 12, padding: '4px 12px', background: '#0369a1', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
              Copy to Clipboard
            </button>
          </div>
        )}
      </div>

      <div style={{ borderTop: '3px solid #16a34a', marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#1a1a1a', paddingTop: 12 }}>Booking Request / Inquiry</h2>
      </div>

      {error && <div style={{ padding: 8, marginBottom: 12, background: '#fef2f2', color: '#dc2626', borderRadius: 6, fontSize: 13, fontWeight: 500 }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
          <div>
            <label className={labelClass}>Name <span style={{ color: 'red' }}>*</span></label>
            <input className={inputClass} value={form.contact_name} onChange={e => handleChange('contact_name', e.target.value)} placeholder="Your Name" />
          </div>
          <div>
            <label className={labelClass}>Phone <span style={{ color: 'red' }}>*</span></label>
            <input className={inputClass} value={form.contact_phone} onChange={e => handleChange('contact_phone', e.target.value)} placeholder="Phone Number" />
          </div>
          <div>
            <label className={labelClass}>Email</label>
            <input className={inputClass} type="email" value={form.contact_email} onChange={e => handleChange('contact_email', e.target.value)} placeholder="Email" />
          </div>
          <div>
            <label className={labelClass}>From <span style={{ color: 'red' }}>*</span></label>
            <input className={inputClass} value={form.from_location_name} onChange={e => handleChange('from_location_name', e.target.value)} placeholder="Origin City" />
          </div>
          <div>
            <label className={labelClass}>To <span style={{ color: 'red' }}>*</span></label>
            <input className={inputClass} value={form.to_location_name} onChange={e => handleChange('to_location_name', e.target.value)} placeholder="Destination City" />
          </div>
          <div>
            <label className={labelClass}>Vehicle Type</label>
            <input className={inputClass} value={form.vehicle_type_name} onChange={e => handleChange('vehicle_type_name', e.target.value)} placeholder="e.g. Reefer, Close Body" />
          </div>
          <div>
            <label className={labelClass}>Vehicle Size</label>
            <input className={inputClass} value={form.vehicle_size} onChange={e => handleChange('vehicle_size', e.target.value)} placeholder="e.g. 24 FT" />
          </div>
          <div>
            <label className={labelClass}>No. of Vehicles</label>
            <input className={inputClass} type="number" min={1} value={form.no_of_vehicles} onChange={e => handleChange('no_of_vehicles', parseInt(e.target.value) || 1)} />
          </div>
          <div>
            <label className={labelClass}>Weight</label>
            <input className={inputClass} value={form.weight} onChange={e => handleChange('weight', e.target.value)} placeholder="Weight" />
          </div>
          <div>
            <label className={labelClass}>Load Type</label>
            <select className={inputClass} value={form.load_type} onChange={e => handleChange('load_type', e.target.value)}>
              <option value="">-- Select --</option>
              <option value="Temp">Temp</option>
              <option value="General">General</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>Trip</label>
            <select className={inputClass} value={form.trip} onChange={e => handleChange('trip', e.target.value)}>
              <option value="">-- Select --</option>
              <option value="Local">Local</option>
              <option value="National">National</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>Trip Type</label>
            <select className={inputClass} value={form.trip_type} onChange={e => handleChange('trip_type', e.target.value)}>
              <option value="">-- Select --</option>
              <option value="Single">Single</option>
              <option value="Round">Round</option>
            </select>
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <label className={labelClass}>Remarks</label>
          <textarea className={inputClass} value={form.remarks} onChange={e => handleChange('remarks', e.target.value)} placeholder="Additional notes..." rows={3} style={{ resize: 'vertical' }} />
        </div>
        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <button type="submit" disabled={submitting}
            style={{ padding: '10px 32px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: submitting ? 0.6 : 1 }}>
            {submitting ? 'Submitting...' : 'Submit Booking Request'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BookingEmbed;
